/* eslint-disable */
export const NAVBAR_USER_MENU_MAIN = `main`;
export const NAVBAR_USER_MENU_LANGUAGE = `language`;
export const NAVBAR_USER_MENU_THEME = `theme`;

/**
 * The width of the navbar menus. This value was taken from [Youtube](https://www.youtube.com/). This is how wide their menus are
 * @type {number}
 */
export const NAVBAR_MENU_WIDTH = 300;
